<wiz-vgroup #vgDetailZone width="100%" height="100%" 
 gap="2" padding="5px" class="section-container">
  
  <wiz-hgroup width="100%" verticalAlign="center" padding="3px">
      <wiz-label #lbTitle width="100%" 
      [wizLabel]="titleLabel"
      class="smallTitleLabel" style="user-select: auto;"></wiz-label>
      <wiz-icon class="image-purple" (click)="doCancel()">close</wiz-icon>
  </wiz-hgroup>

  <!-- nom du champ et formule -->
  <wiz-vgroup verticalAlign="center" width="100%">
    <div class="listItemFont" spellcheck="false" width="100%" [innerHtml]="contentLabel" style="overflow-y: auto"></div>
  </wiz-vgroup>

  <wiz-spacer height="20px"></wiz-spacer>

  <wiz-hgroup [width]="'100%'"> <!-- navbar -->
    <wiz-tab-bar #tabBar class="popBar" [width]="'100%'"
    [showNavigation]="false"
    [wizButtonList]="tabs"></wiz-tab-bar>
  </wiz-hgroup>


  <!-- entêtes -->
  <wiz-vgroup *ngIf="headTab" width="100%" height='100%' padding="5px" gap="10">  
    <!-- libellé & alignement -->
    <wiz-hgroup width="100%" gap="20">
      <wiz-vgroup>
        <wiz-text-input id="tiLabel"
        width="200px" 
        [wizLabel]="'$.common.label.$'" 
        [wizValue]="customHeaderTitle"
        [wizMaxChars]="50"> </wiz-text-input>

        <wiz-dropdown *ngIf="useCssStyle"
          #ddCssStyle
          width="150px"
          [wizLabelField]="'trsLabel'"
          [wizDataProvider] = "cssStyleDS"
          [wizLabel]="'$.pivot.edit.field.style.$'"></wiz-dropdown>  
      </wiz-vgroup>

      <!-- alignement -->  
      <wiz-dropdown *ngIf="useHeaderTextAlign" width="100px" 
      [wizLabelField]="'trsLabel'" 
      [wizDataProvider]="headerAlignDS"
      [wizLabel]="'$.common.text.align.$'"></wiz-dropdown>
      
      <wiz-vgroup gap="0">
        <wiz-checkbox #cbHidden id="cbHidden" *ngIf="!isFilter" 
          [wizLabel]="'$.measure.show.hide.$'"
          [wizChecked]="hidden"
          style="padding-top: 15px;"
          ></wiz-checkbox>
        <wiz-checkbox #cbExport id="cbExport" *ngIf="!isFilter"
          [wizLabel]="'$.widget.column.exportable.$'"
          [wizChecked]="exportable"
          style="padding-top: 15px;"
          ></wiz-checkbox>
      </wiz-vgroup>


    </wiz-hgroup>

    <wiz-text-input *ngIf="usePivotHeaderColors" id="tiHeadSub"
          width="120px" 
          [wizLabel]="'$.header.sub.$'" 
          [wizValue]="headSubField"
          [wizMaxChars]="100"> </wiz-text-input>

    <!-- gestion du resize et de la taille des colonnes -->
    <wiz-hgroup #gpColumn wizValidationContainer 
      *ngIf="useColumn" width="100%" gap="20">
      <wiz-checkbox #cbColResize id="cbColResize" *ngIf="!isFilter" 
      [wizLabel]="'$.pivot.edit.column.rezisable.$'"
      [wizChecked]="colResize"
      style="padding-top: 15px;"
      ></wiz-checkbox>
      <wiz-numeric-input
        #niColWidth id="niColWidth"
        width="100px"
        wizMinNumber="0"
        wizMaxNumber="700"
        nbDecimal="0"
        [wizLabel]="'$.pivot.edit.column.size.$'"
        [wizNumber]="colWidth"
        wizValidator
        [wizShowErrors]="true"
      ></wiz-numeric-input>
      <wiz-numeric-input *ngIf="!isFilter"
        #niColMinWidth id="niColMinWidth"
        width="100px"
        wizMinNumber="0"
        wizMaxNumber="700"
        nbDecimal="0"
        [wizLabel]="'$.pivot.edit.column.minsize.$'"
        [wizNumber]="colMinWidth"
        [visible]="resizeEnabled"
      ></wiz-numeric-input>
      <wiz-checkbox #cbColAuto id="cbColAuto" *ngIf="!isFilter"
        [wizLabel]="'$.pivot.edit.column.auto.$'"
        [wizChecked]="colAuto"
        style="padding-top: 15px;"
        ></wiz-checkbox>
    </wiz-hgroup>
    
    <!-- groupe de colonnes d'appartenance -->  
     <wiz-hgroup>
        <wiz-dropdown *ngIf="useHeaderGroup" 
        width="250px" 
        [wizDataProvider]="groupDS"
        [wizLabelField]="'dropGroupLabel'" 
        [wizLabel]="'$.pivot.edit.field.groupmember.$'"></wiz-dropdown>
        <wiz-checkbox *ngIf="useHeaderInherit && useHeaderGroup" id="cbHeadInherit" 
          [wizLabel]="'$.header.style.inherit.$'"
          [wizChecked]="headInherit"
          style="padding-top: 15px;"
          ></wiz-checkbox>    
     </wiz-hgroup>


      <!-- couleurs d'entête -->  
    <wiz-hgroup #headerColors *ngIf="useHeaderColors" width="100%" >
        <wiz-vgroup width="110px">
          <wiz-label wizLabel="$.style.css.fontcolor.$" style="font-size: 11px; font-weight: bold;"></wiz-label>
          <wiz-hgroup>
            <span
              #blockFont
              [style.backgroundColor]="fontColor"
              style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
              width="20px"
              height="20px"
              (click)="showColorPicker($event)"
            ></span>
            <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('blockFont')">removal</wiz-icon>
          </wiz-hgroup>
        </wiz-vgroup>
        <wiz-vgroup width="110px">
          <wiz-label wizLabel="$.style.css.backgroundcolor.$" style="font-size: 11px; font-weight: bold;"></wiz-label>
          <wiz-hgroup>
            <span
              #blockBack
              [style.backgroundColor]="backgroundColor"
              width="20px"
              height="20px"
              (click)="showColorPicker($event)"
              style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
            ></span>
            <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('blockBack')">removal</wiz-icon>
          </wiz-hgroup>
        </wiz-vgroup>

        <wiz-text-input *ngIf="usePivotHeaderColors" id="tiHeadColorField"
              width="120px" 
              [wizLabel]="'$.header.color.field.$'" 
              [wizValue]="headColorField"
              [wizMaxChars]="100"> </wiz-text-input>      

    </wiz-hgroup>

  </wiz-vgroup>

  <!-- cellules / content -->
  <wiz-vgroup *ngIf="contentTab" width="100%" height='100%' padding="5px" gap="10">    
    
    <!-- readOnly -->
    <wiz-checkbox id="cbReadOnly" *ngIf="useFormatReadonly" 
    [wizLabel]="'$.pivot.edit.field.readonly.$'"
    [wizChecked]="readOnly"
    ></wiz-checkbox>
    <!-- mode split sur massEdit -->
    <wiz-checkbox id="cbMassSplit" *ngIf="useMassEditSplit" 
    [wizLabel]="'$.pivot.edit.field.masssplit.$'"
    [wizChecked]="massEditSplit"
    ></wiz-checkbox>
  
    <!-- choix des champs pour chrono / FDV -->
    <wiz-hgroup width="100%" *ngIf="useKey">
      <wiz-dropdown
        #ddField id="ddField" *ngIf="useFormatField"
        width="200px"
        [wizDataProvider] = "fieldDS"
        [wizLabelField]="'trsLabel'"
        [wizLabel]="'$.pivot.edit.field.field.$'"></wiz-dropdown>

      <wiz-dropdown 
        #ddChronoField *ngIf="useFormatChronoField" id="ddChronoField"
        width="200px"
        [wizDataProvider] = "chronoFieldDS"
        [wizLabelField]="'trsLabel'"
        [wizLabel]="'$.pivot.edit.field.field.$'"></wiz-dropdown>
    </wiz-hgroup>

    <!-- méthode d'aggrégat et format -->
    <wiz-hgroup width="100%">
      <!-- TODO TODO DDFUNC seulement si PIVOT SANS totaux -->
      <wiz-dropdown
      #ddFunc id="ddFunc" *ngIf="useAggregate"
      width="200px"
      [wizDataProvider] = "functionDS"
      [wizLabelField]="'fullName'"
      [wizLabel]="'$.pivot.edit.field.agg.method.$'"
      wizMandatory="true"
      wizPanelWidth="250px"
      ></wiz-dropdown>

      <wiz-numeric-input *ngIf="useStep"
        #niStep id="niStep"
        width="100px"
        wizMinNumber="0"
        wizMaxNumber="10"
        nbDecimal="0"
        [wizLabel]="'$.step.title.$'"
        [wizNumber]="step"

      ></wiz-numeric-input>

      <wiz-dropdown
      #ddFormat *ngIf="useFormat"
      width="200px"
      [wizDataProvider]="formatDS"
      [wizLabelField]="'trsLabel'"
      [wizLabel]="'$.pivot.edit.field.format.$'"></wiz-dropdown>

    </wiz-hgroup>

    <!-- rendu constant des cellules -->
    <wiz-hgroup width="100%" *ngIf="useStyle">
        <wiz-vgroup width="120px">
          <wiz-label wizLabel="$.style.css.fontcolor.$" style="font-size: 11px; font-weight: bold;"></wiz-label>
          <wiz-hgroup>
            <span
              #cellBlockFont
              [style.backgroundColor]="cellFontColor"
              style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
              width="20px"
              height="20px"
              (click)="showColorPicker($event)"
            ></span>
            <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('cellBlockFont')">removal</wiz-icon>
            <wiz-text-input id="tiFontMeasure" *ngIf="useStyleMeasure"
            width="200px" 
            [wizShowLabel]="false"
            [wizValue]="fontMeasure"
            [wizMaxChars]="100"> </wiz-text-input>
          </wiz-hgroup>

        </wiz-vgroup>
        <wiz-vgroup width="120px">
          <wiz-label wizLabel="$.style.css.backgroundcolor.$" style="font-size: 11px; font-weight: bold;"></wiz-label>
          <wiz-hgroup>
            <span
              #cellBlockBack
              [style.backgroundColor]="cellBackgroundColor"
              width="20px"
              height="20px"
              (click)="showColorPicker($event)"
              style="cursor: pointer; border-radius: 20px; border-style: solid; border-width: 1px"
            ></span>
            <wiz-icon style="cursor: pointer; font-size: 20px" (click)="resetColor('cellBlockBack')">removal</wiz-icon>
            <wiz-text-input id="tiBackMeasure" *ngIf="useStyleMeasure"
            width="200px" 
            [wizShowLabel]="false"
            [wizValue]="backMeasure"
            [wizMaxChars]="100"> </wiz-text-input>
          </wiz-hgroup>
        </wiz-vgroup>

        <!-- bold -->
        <wiz-checkbox id="cbBold"
        [wizLabel]="'$.style.css.bold.$'"
        [wizChecked]="isBold"></wiz-checkbox>

    </wiz-hgroup>

    <!-- style conditionnel des cellules -->
    <wiz-hgroup width="100%" *ngIf="useStyle">
      <wiz-dropdown
        #ddStyle id="ddStyle"
        width="150px"
        [visible]="mayEditStyle"
        [wizDataProvider] = "styleDS"
        [wizLabelField]="'code'"
        [wizLabel]="'$.pivot.edit.field.condstyle.$'"></wiz-dropdown>

      <wiz-icon #btEditStyle 
      [visible]="editStyleEnabled"
      style="cursor: pointer; font-size: 20px; padding-top: 20px" (click)="editStyle()"
      >style</wiz-icon>
      <wiz-icon [visible]="mayEditStyle" style="cursor: pointer; font-size: 20px; padding-top: 20px" (click)="addStyle()"
      >creation</wiz-icon>

      <wiz-dropdown
        #ddStyleConso id="ddStyleConso"
        width="150px"
        [visible]="mayEditStyleConso"
        [wizDataProvider] = "styleDSConso"
        [wizLabelField]="'code'"
        [wizLabel]="'$.row.style.func.$'"></wiz-dropdown>

    </wiz-hgroup>

  </wiz-vgroup>

  <!-- contenu avancé (settings sur workflow) -->
  <wiz-vgroup *ngIf="advancedTab" width="100%" height='100%' padding="5px" gap="10">    
      <wiz-text-area
        #taSettings id="taSettings"
        [wizLabel]="'$.mesure.settings.$'"
        [wizValue]="moreSettings"
        width="100%"
        height="100%"
        [wizMaxChars]="2000"
      ></wiz-text-area>
  </wiz-vgroup>

  <!-- totaux -->
  <wiz-vgroup *ngIf="totalTab" width="100%" height='100%' padding="5px" gap="10">
    <wiz-dropdown
    #ddTotalFunc id="ddTotalFunc" *ngIf="!useColumnTotal"
    width="200px"
    [wizDataProvider] = "totalFunctionDS"
    [wizLabelField]="'fullName'"
    [wizLabel]="'$.pivot.edit.field.agg.method.$'"
    wizMandatory="true"
    wizPanelWidth="250px"
    ></wiz-dropdown>

    <wiz-text-input *ngIf="totalModeCompute && !useColumnTotal" id="totalMeasure" 
      width="200px" 
      [wizLabel]="'$.pivot.edit.field.totagg.measure.$'" 
      [wizValue]="customTotalMeasure"
      [wizMaxChars]="50"> </wiz-text-input>

    <wiz-dropdown *ngIf="!useColumnTotal" 
    #ddTotalFormat
    width="200px"
    [wizDataProvider]="totalFormatDS"
    [wizLabelField]="'trsLabel'"
    [wizLabel]="'$.pivot.edit.field.format.$'"></wiz-dropdown>

    <wiz-checkbox #cbColTot id="cbColTot" *ngIf="useColumnTotal" 
        [wizLabel]="'$.column.total.$'"
        [wizChecked]="colTot"
        style="padding-top: 15px;"
        ></wiz-checkbox>

    <wiz-text-input id="tiColTotLabel" *ngIf="useColumnTotal"
      width="200px" 
      [wizLabel]="'$.common.label.$'" 
      [wizValue]="customColTotLabel"
      [wizMaxChars]="50"> </wiz-text-input>



  </wiz-vgroup>

  <!-- filtres -->
  <wiz-vgroup *ngIf="filterTab" width="100%" height='100%' padding="5px">

    <wiz-hgroup wizValidationContainer width="100%" gap="20">
      <wiz-checkbox id='cbHideFilter' *ngIf="useHeaderHideFilter" 
      [wizLabel]="'$.pivot.edit.filter.hidden.$'"
      [wizChecked]="hideFilter"
      ></wiz-checkbox>
  
      <wiz-checkbox id='cbMandatoryFilter' 
      [wizLabel]="'$.common.mandatory.$'"
      [wizChecked]="mandatoryFilter"
      ></wiz-checkbox>

      <wiz-checkbox id='cbStrictFilter' 
      [wizLabel]="'$.common.strict.$'"
      [wizChecked]="strictFilter"
      ></wiz-checkbox>

      <wiz-checkbox id="cbExistValueFilter" 
      *ngIf="useHeaderOnlyExist"  
      [wizLabel]="'$.pivot.edit.filter.allvalues.$'"
      [wizChecked]="onlyExist"
      ></wiz-checkbox>
    </wiz-hgroup>

    <wiz-vgroup *ngIf="useSearchFields" width="100%" height='100%'>
      <wiz-label [wizLabel]="'$.pivot.edit.field.fields.$'" style="font-size: 11px; font-weight: bold;"></wiz-label>
      <wiz-ag-grid  #agGrid width="100%" height="100%" 
      class="ag-theme-alpine"
      [gridOptions]="gridOptions"
      [wizDatasource]="fieldsDS"
      [columnDefs]="columns"
      [wizRowSelection]="'multiple'"
      [dndConfig]="dndConfig"
      ></wiz-ag-grid>
    </wiz-vgroup>

  </wiz-vgroup>

  <wiz-hgroup width="100%" height="45px" padding="5px" horizontalAlign="end" verticalAlign="center">
    <wiz-button
      #btnSave
      [wizLabel]="'$.common.save.modification.$'"
      [wizIcon]="'icon-arrow-right'"
      (click)="save()"
      [iconPlacement]="'right'"
    ></wiz-button>
    <wiz-button
      #btnCancel
      class="cancel-button"
      [wizIcon]="'icon-arrow-left'"
      (click)="doCancel()"
      [wizLabel]="'$.common.cancel.modification.$'"
    ></wiz-button>
  </wiz-hgroup>
</wiz-vgroup>
